<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-binvoice-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-8">
              <h3 class="mb-0 view-header-buttons">
                {{ salesInvoice.seq_number ?? salesInvoice.code }}
                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="editSalesInvoice()"
                  v-if="salesInvoice.status === INVOICE_STATUS_DRAFT"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    salesInvoice.status === INVOICE_STATUS_DRAFT &&
                    $currentUserCan($permissions.PERM_DELETE_SALES_INVOICES)
                  "
                  type="danger"
                  icon
                  size="sm"
                  @click="deleteSalesInvoice()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>

                <!-- <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="validateSalesInvoice()"
                  :disabled="loading"
                  v-if="
                    salesInvoice.items.length > 0 &&
                    salesInvoice.status === INVOICE_STATUS_DRAFT
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-check-bold"></i>
                    {{ $t("SALES_INVOICES.VALIDATE") }}
                  </span>
                </base-button>

                <base-button
                  v-if="salesInvoice.status === INVOICE_STATUS_VALIDATED"
                  type="primary"
                  icon
                  size="sm"
                  @click="addSalesPayment()"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-money-coins"></i>
                    {{ $t("SALES_INVOICES.ADD_PAYMENT") }}
                  </span>
                </base-button> -->

                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="viewSalesOrder()"
                  :disabled="loading"
                  v-if="salesInvoice.salesOrder"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-bag-17"></i>
                    {{ $t("SALES_INVOICES.VIEW_ORDER") }}
                  </span>
                </base-button>

                <base-button
                  type="danger"
                  icon
                  size="sm"
                  @click="cancelSalesInvoice()"
                  :disabled="loading"
                  v-if="canCancelSalesInvoice"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-fat-remove"></i>
                    {{ $t("SALES_INVOICES.CANCEL") }}
                  </span>
                </base-button>

                <base-button
                  type="info"
                  icon
                  size="sm"
                  @click="print()"
                  :disabled="loading"
                  v-if="
                    salesInvoice.status !== INVOICE_STATUS_DRAFT &&
                    salesInvoice.status !== INVOICE_STATUS_CANCELED
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-file-pdf"></i>
                    {{ $t("COMMON.PRINT") }}
                  </span>
                </base-button>

                <base-button
                  type="success"
                  icon
                  size="sm"
                  @click="toggleMailModal()"
                  :disabled="loading"
                  v-if="
                    salesInvoice.status !== INVOICE_STATUS_DRAFT &&
                    salesInvoice.status !== INVOICE_STATUS_CANCELED
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-envelope"></i>
                    {{ $t("COMMON.SEND") }}
                  </span>
                </base-button>
                
                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="openInvoicingDateModal()"
                  :disabled="loading"
                  v-if="$currentUserCan($permissions.PERM_EDIT_SALES_INVOICES)"
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-calendar"></i>
                    {{ $t("INVOICES.UPDATE_INVOICING_DATE") }}
                  </span>
                </base-button>

                <base-button
                  type="info"
                  icon
                  size="sm"
                  @click="recalculatePricing()"
                  :disabled="loading"
                  v-if="
                    salesInvoice.status !== INVOICE_STATUS_CANCELED &&
                    $currentUserCan($permissions.PERM_EDIT_SALES_INVOICES)
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-calculator"></i>
                    {{ $t("COMMON.RECALCULATE") }}
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>

              <notification-subscription
                :objectType="'sales-invoices'"
                :objectId="salesInvoice.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap tabs-wrapper"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="details"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="false">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <sales-invoice-view-global :salesInvoice="salesInvoice" />
                </tab-pane>

                <tab-pane title="details" id="2" :active="false">
                  <span slot="title">
                    <i class="ni ni-bullet-list-67" />
                    {{ $t("COMMON.DETAILS") }}
                  </span>
                  <sales-invoice-view-details
                    :salesInvoice="salesInvoice"
                    @salesInvoiceItemsUpdated="get"
                  />
                </tab-pane>

                <tab-pane
                  title="payments"
                  id="3"
                  :active="false"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_SALES_PAYMENTS)
                  "
                >
                  <span slot="title">
                    <i class="ni ni-money-coins" />
                    {{ $t("COMMON.PAYMENTS") }}
                  </span>
                  <sales-invoice-view-payments
                    :get="get"
                    :salesInvoice="salesInvoice"
                  />
                </tab-pane>

                <tab-pane
                  title="files"
                  id="998"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_FILES) &&
                    salesInvoice.organization
                  "
                >
                  <span slot="title">
                    <i class="ni ni-folder-17" />
                    {{ $t("COMMON.FILES") }}
                  </span>
                  <list-file-component :object="salesInvoice" />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <sales-invoice-view-logs :salesInvoice="salesInvoice" />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>

    <modal :show="showMailModal" modal-classes="modal-secondary" size="xl">
      <sales-invoice-mail-modal-content
        :salesInvoice="salesInvoice"
        :get="get"
        :toggleMailModal="toggleMailModal"
      />
    </modal>

    <modal
      :show="showCancelModal"
      modal-classes="modal-secondary"
      @close="closeCancelModal"
    >
      <div class="text-center mb-4">
        <h3>{{ $t("SALES_INVOICES.CANCEL_SALES_INVOICE_QUESTION") }}</h3>
      </div>
      <base-input
        :label="`${$t('SALES_INVOICES.CANCELLATION_REASON')} (*)`"
        :error="cancelErrors.cancellation_reason"
      >
        <textarea
          class="form-control"
          rows="4"
          v-model="cancelReason"
          :placeholder="$t('SALES_INVOICES.CANCELLATION_REASON_PLACEHOLDER')"
        ></textarea>
      </base-input>
      <base-checkbox v-model="cancelSendMail" class="mb-3">
        {{ $t("SALES_INVOICES.SEND_CANCELLATION_EMAIL") }}
      </base-checkbox>
      <base-input
        v-if="cancelSendMail"
        type="email"
        :label="$t('SALES_INVOICES.RECIPIENT_EMAIL')"
        v-model="cancelRecipientEmail"
        :error="cancelErrors.recipient_email"
      />
      <template slot="footer">
        <base-button
          type="primary"
          class="mr-2"
          @click="confirmCancelSalesInvoice"
          :disabled="loading"
        >
          <i class="fas fa-spinner fa-spin" v-if="loading" />
          {{ $t("COMMON.YES") }}
        </base-button>
        <base-button type="secondary" @click="closeCancelModal">
          {{ $t("COMMON.NO") }}
        </base-button>
      </template>
    </modal>

    <modal
      :show="showInvoicingDateModal"
      modal-classes="modal-secondary"
      @close="closeInvoicingDateModal"
    >
      <div class="text-center mb-4">
        <h3>{{ $t("INVOICES.INVOICING_DATE") }}</h3>
      </div>
      <base-input :label="$t('INVOICES.INVOICING_DATE')">
        <flat-picker
          :config="{ allowInput: true, locale: $flatPickrLocale() }"
          class="form-control datepicker"
          v-model="invoicingDateInput"
        />
      </base-input>
      <template slot="footer">
        <base-button
          type="primary"
          class="mr-2"
          @click="saveInvoicingDate"
          :disabled="loading"
        >
          <i class="fas fa-spinner fa-spin" v-if="loading" />
          {{ $t("COMMON.SAVE") }}
        </base-button>
        <base-button type="secondary" @click="closeInvoicingDateModal">
          {{ $t("COMMON.CLOSE") }}
        </base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import moment from "moment";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  INVOICE_STATUS_CANCELED,
  INVOICE_STATUS_DRAFT,
  INVOICE_STATUS_VALIDATED,
} from "@/constants/invoices";
import { openPdfBlob } from "@/helpers/downloadPdf";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { TabPane, Tabs } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import SalesInvoiceViewGlobal from "./partials/SalesInvoiceViewGlobal.vue";
import SalesInvoiceViewDetails from "./partials/SalesInvoiceViewDetails.vue";
import SalesInvoiceViewLogs from "./partials/SalesInvoiceViewLogs.vue";
import defaultSalesInvoice from "./defaultSalesInvoice";
import SalesInvoiceViewPayments from "./partials/SalesInvoiceViewPayments.vue";
import SalesInvoiceMailModalContent from "./partials/SalesInvoiceMailModalContent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    SalesInvoiceViewGlobal,
    SalesInvoiceViewDetails,
    SalesInvoiceViewLogs,
    ListFileComponent,
    NotificationSubscription,
    SalesInvoiceViewPayments,
    SalesInvoiceMailModalContent,
    flatPicker,
  },

  mixins: [requestErrorMixin],

  data() {
    return {
      loading: false,
      showMailModal: false,
      showInvoicingDateModal: false,
      invoicingDateInput: null,
      showCancelModal: false,
      cancelReason: "",
      cancelSendMail: false,
      cancelRecipientEmail: "",
      cancelErrors: {
        cancellation_reason: null,
        recipient_email: null,
      },
      salesInvoice: cloneDeep(defaultSalesInvoice),
      INVOICE_STATUS_DRAFT: INVOICE_STATUS_DRAFT,
      INVOICE_STATUS_CANCELED: INVOICE_STATUS_CANCELED,
      INVOICE_STATUS_VALIDATED: INVOICE_STATUS_VALIDATED,
    };
  },

  computed: {
    canCancelSalesInvoice() {
      if (
        !this.$currentUserCan(this.$permissions.PERM_CANCEL_SALES_INVOICES)
      ) {
        return false;
      }
      if (
        this.salesInvoice.status === INVOICE_STATUS_CANCELED ||
        this.salesInvoice.status === INVOICE_STATUS_DRAFT
      ) {
        return false;
      }
      if (this.salesInvoice.status === INVOICE_STATUS_VALIDATED) {
        if (this.salesInvoice.total_paied != 0) {
          return false;
        }
        return true;
      }
      return false;
    },
  },

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("salesInvoices/get", id);
        this.salesInvoice = this.$store.getters["salesInvoices/salesInvoice"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editSalesInvoice(row) {
      this.$router.push({
        name: "Edit SalesInvoice",
        params: { id: this.salesInvoice.id },
      });
    },

    async validateSalesInvoice() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "salesInvoices/validate",
          this.salesInvoice.id
        );
        this.salesInvoice = this.$store.getters["salesInvoices/salesInvoice"];
        this.$notify({
          type: "success",
          message: this.$t("SALES_INVOICES.SALES_INVOICE_VALIDATED"),
        });
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async recalculatePricing() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "salesInvoices/recalculate",
          this.salesInvoice.id
        );
        this.salesInvoice =
          this.$store.getters["salesInvoices/salesInvoice"];
        this.$notify({
          type: "success",
          message: this.$t("COMMON.RECALCULATE_SUCCESS"),
        });
        await this.get();
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },

    cancelSalesInvoice() {
      this.cancelReason = "";
      this.cancelSendMail = false;
      this.cancelRecipientEmail =
        this.getLastSentToEmail(this.salesInvoice) ||
        this.getSentToFirstEmail(
          this.salesInvoice && this.salesInvoice.salesOrder
            ? this.salesInvoice.salesOrder.sent_to
            : null
        ) ||
        (this.salesInvoice.recipient &&
          (this.salesInvoice.recipient.billing_email ||
            this.salesInvoice.recipient.email)) ||
        "";
      this.cancelErrors.cancellation_reason = null;
      this.cancelErrors.recipient_email = null;
      this.showCancelModal = true;
    },

    getLastSentToEmail(invoice) {
      return this.getSentToFirstEmail(invoice && invoice.sent_to);
    },

    getSentToFirstEmail(sentTo) {
      if (!sentTo) return "";
      if (typeof sentTo === "string") return sentTo;
      if (Array.isArray(sentTo)) return sentTo[0] || "";
      if (typeof sentTo === "object") {
        const to = sentTo.to;
        if (Array.isArray(to)) return to[0] || "";
        if (typeof to === "string") return to;
      }
      return "";
    },

    closeCancelModal() {
      this.showCancelModal = false;
    },

    async confirmCancelSalesInvoice() {
      this.cancelErrors.cancellation_reason = null;
      this.cancelErrors.recipient_email = null;

      const reason = (this.cancelReason || "").trim();
      const recipientEmail = (this.cancelRecipientEmail || "").trim();

      if (!reason) {
        this.cancelErrors.cancellation_reason = this.$t(
          "SALES_INVOICES.CANCELLATION_REASON_REQUIRED"
        );
        return;
      }
      if (this.cancelSendMail && !recipientEmail) {
        this.cancelErrors.recipient_email = this.$t(
          "SALES_INVOICES.RECIPIENT_EMAIL_REQUIRED"
        );
        return;
      }

      try {
        this.loading = true;
        await this.$store.dispatch("salesInvoices/cancel", {
          id: this.salesInvoice.id,
          cancellation_reason: reason,
          send_mail: this.cancelSendMail,
          recipient_email: this.cancelSendMail ? recipientEmail : null,
        });
        this.salesInvoice = this.$store.getters["salesInvoices/salesInvoice"];
        this.$notify({
          type: "success",
          message: this.$t("SALES_INVOICES.SALES_INVOICE_CANCELED"),
        });
        this.showCancelModal = false;
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async deleteSalesInvoice() {
      const confirmation = await swal.fire({
        title: this.$t("SALES_INVOICES.DELETE_THIS_SALES_INVOICE"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch(
            "salesInvoices/destroy",
            this.salesInvoice.id
          );
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("SALES_INVOICES.SALES_INVOICE_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async viewSalesOrder() {
      this.$router.push(this.$objectViewRoute(this.salesInvoice.salesOrder));
    },

    async addSalesPayment(row) {
      this.$router.push({
        name: "Add SalesPayment",
        query: {
          invoice_id: this.salesInvoice.id,
          amount: this.salesInvoice.total_remaining_payment.toFixed(2),
        },
      });
    },

    goBack() {
      this.$router.push({ name: "List SalesInvoices" });
    },

    toggleMailModal() {
      this.showMailModal = !this.showMailModal;
    },

    async print() {
      swal.fire({
        title: `Chargement`,
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
      try {
        const response = await this.$store.dispatch(
          "salesInvoices/print",
          this.salesInvoice.id
        );

        openPdfBlob(response, `${this.salesInvoice.seq_number || this.salesInvoice.code}.pdf`);

        swal.close();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
        this.setApiValidation(error.response.data.errors);
        swal.close();
      }
    },

    openInvoicingDateModal() {
      this.invoicingDateInput = this.salesInvoice.invoicing_date
        ? moment(this.salesInvoice.invoicing_date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
      this.showInvoicingDateModal = true;
    },

    closeInvoicingDateModal() {
      this.showInvoicingDateModal = false;
      this.apiValidationErrors = {};
    },

    async saveInvoicingDate() {
      try {
        this.loading = true;
        await this.$store.dispatch("salesInvoices/updateInvoicingDate", {
          id: this.salesInvoice.id,
          invoicing_date: this.$getUtcDateTimeString(
            moment(this.invoicingDateInput).hour(12).minute(0).second(0).toISOString()
          ),
        });
        this.salesInvoice = this.$store.getters["salesInvoices/salesInvoice"];
        this.showInvoicingDateModal = false;
        this.$notify({
          type: "success",
          message: this.$t("COMMON.UPDATED"),
        });
        this.get();
      } catch (error) {
        console.log(error);
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
